import Cookies from "js-cookie";
import { BASE_URL } from "../constants";
import { UserContextEntity } from "../entities/UserEntity";
import FetchUtils from "../utils/fetch";
import WebEncrypt from "../utils/web_encrypt";

class AuthService {
    async login(username: string, password: string) {
        if (username === '' || password === '') throw Error("Username and password are required!");
        try {
            let creds = JSON.stringify({ user: username, pwd: password });

            // if (window.location.protocol == 'http:') {
                const key = await fetch(`${BASE_URL}/api/v1/auth/key`, { method: "GET" });
                const publicKey = await key.json();
                if (key.status !== 200) { throw new Error(publicKey.message); }
                
                creds = await WebEncrypt.encryptSubtleCrypto(JSON.stringify({ user: username, pwd: password }), publicKey.data)
            // }

            const resp = await fetch(`${BASE_URL}/api/v1/auth`, {
                method: "POST",
                body: creds,
            });
            const body = { ...(await resp.json()), status: resp.status }

            if (body.status !== 200) {
                Cookies.remove("token");
                Cookies.remove("refreshToken");
                throw Error(body.message);
            } else {
                if (body.data.accessToken == null || body.data.refreshToken == null) throw Error(body.message);

                console.log("Login Success");
                Cookies.set("token", body.data.accessToken);
                Cookies.set("refreshToken", body.data.refreshToken);
                return new UserContextEntity({ username: body.data.username, rolename: body.data.rolename, vendor: body.data.vendor });
            }
        } catch (error) {
            Cookies.remove("token");
            Cookies.remove("refreshToken");
            throw error;
        }
    }

    async refreshLogin() {
        if (Cookies.get("refreshToken") == null || Cookies.get("refreshToken") == "") return;
        try {
            const resp = await fetch(`${BASE_URL}/api/v1/auth/refresh`, {
                method: "POST",
                credentials: "include"
            });
            if (resp.status !== 200) throw new Error("TOKEN EXPIRED");
            const body = await resp.json();

            console.log("Token Refreshed");
            Cookies.set("token", body.data.accessToken);
            Cookies.set("refreshToken", body.data.refreshToken);
            return new UserContextEntity({ username: body.data.username, rolename: body.data.rolename, vendor: body.data.vendor });
        } catch (error) {
            Cookies.remove("token");
            Cookies.remove("refreshToken");
            throw error;
        }
    }

    async changePass(password: string, newpassword: string) {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/auth/change_pass`, {
            method: "POST",
            body: JSON.stringify({ password: password, newpassword: newpassword })
        });
        if (resp.status !== 200) throw Error(resp.message);
        return resp;
    }

    async logout() {
        Cookies.remove("token");
        Cookies.remove("refreshToken");
    }
}

export { AuthService }